export default __webpack_public_path__ + "static/media/stripe.6d4b8cc4.svg";